import React, { Component } from "react";

export default class NoData extends Component {
  render() {
    return <div style={{ color: "#009c9f" }}>No Data</div>;
  }
}
